import { styled } from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const InterSectionObserverObject = styled.div`
  position: absolute;
  top: 25%;
  height: 50vh;
  width: 100%;
  pointer-events: none;
`;
